import { render, staticRenderFns } from "./tripRight.vue?vue&type=template&id=18838d14&scoped=true"
import script from "./tripRight.vue?vue&type=script&lang=js"
export * from "./tripRight.vue?vue&type=script&lang=js"
import style0 from "./tripRight.vue?vue&type=style&index=0&id=18838d14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18838d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18838d14')) {
      api.createRecord('18838d14', component.options)
    } else {
      api.reload('18838d14', component.options)
    }
    module.hot.accept("./tripRight.vue?vue&type=template&id=18838d14&scoped=true", function () {
      api.rerender('18838d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/tripRight.vue"
export default component.exports